import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const StyleFilterPublicIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="16px Icons">
        <path id="Ellipse 5995" d="M3 12C5.20914 12 7 10.2091 7 8C7 5.79086 5.20914 4 3 4V12Z" fill={fillColor || '#4CAF00'} />
        <path id="Ellipse 5996" d="M7 14C10.3137 14 13 11.3137 13 8C13 4.68629 10.3137 2 7 2V14Z" fill={fillColor || '#4CAF00'} />
      </g>
    </svg>
  );
};

export { StyleFilterPublicIcon };
